// extracted by mini-css-extract-plugin
export default {"indicator":"indicator_indicator__U31dy","marker":"indicator_marker__-wZ4j","indicator-group":"indicator_indicator-group__yjN2o","inside":"indicator_inside__YP1UW"};